import { AlertCircle } from "lucide-react-native";
import { FC } from "react";

import { useLocalization } from "@/hooks";

import { Button, ButtonText, Center, Text } from "./base";

interface ErrorWithRetryProps {
  error: string;
  onRetry: () => void;
  retrying?: boolean;
  title?: string;
}

const ErrorWithRetry: FC<ErrorWithRetryProps> = ({
  error,
  onRetry,
  retrying = false,
  title,
}) => {
  const { i18n } = useLocalization();

  return (
    <Center className="flex-1">
      <AlertCircle color="rgb(var(--color-error-500))" size={48} />
      <Text className="text-xl font-bold text-typography-900 mt-4">
        {title || i18n.t("misc.errorOccurred")}
      </Text>
      <Text className="text-sm text-error-500 mt-2 text-center">{error}</Text>
      <Button
        className="mt-6 rounded-xl bg-gradient-to-r from-primary-300 to-secondary-300"
        isDisabled={retrying}
        onPress={onRetry}
      >
        <ButtonText className="font-bold text-white">
          {retrying ? i18n.t("misc.retrying") : i18n.t("misc.tryAgain")}
        </ButtonText>
      </Button>
    </Center>
  );
};

export default ErrorWithRetry;
